import { Component, EventEmitter, Input, Output } from "@angular/core";
import { COMMA, ENTER } from "@angular/cdk/keycodes";

import { MatChipInputEvent } from "@angular/material/chips";
import { SnackbarService } from "../../services/snackbar/snackbar.service";
import { TranslateService } from "@ngx-translate/core";
import { SnackbarType } from "src/app/models/snackbar/snackbar.model";

@Component({
  selector: "app-search-filter",
  templateUrl: "./search-filter.component.html",
  styleUrls: ["./search-filter.component.scss"],
})
export class SearchFilterComponent {
  @Input() searchTerms: string[];
  @Input() searchTooltipText: string;

  @Output()
  searchChanged: EventEmitter<string[]> = new EventEmitter<string[]>();

  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  searchInput: string;

  constructor(
    private translate: TranslateService,
    private snackbarService: SnackbarService
  ) { }

  searchClicked() {
    if (this.searchInput.length > 100) {
      this.snackbarService.show({
        message: this.translate.instant("SimpleFilter.searchTermMaxLength"),
        type: SnackbarType.ERROR,
      });
      return;
    }

    if ((this.searchInput || "").trim()) {
      this.searchTerms.push(this.searchInput.trim());
      this.searchChanged.emit(this.searchTerms);
    }

    this.searchInput = "";
  }

  addSearchTerm(event: MatChipInputEvent): void {
    const { input, value } = event;

    if ((value || "").trim()) {
      this.searchTerms = [...this.searchTerms, value.trim()];
      this.searchChanged.emit(this.searchTerms);
    }

    if (input) {
      input.value = "";
    }

    this.searchInput = "";
  }

  removeSearchTerm(searchTerm: string): void {
    const index = this.searchTerms.indexOf(searchTerm);

    if (index >= 0) {
      this.searchTerms = this.searchTerms.filter((term, i) => i !== index);
      this.searchChanged.emit(this.searchTerms);
    }
  }

  clearSearchTerms(): void {
    this.searchTerms = [];
    this.searchChanged.emit(this.searchTerms);
  }
}
